import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6f36020e&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f36020e')) {
      api.createRecord('6f36020e', component.options)
    } else {
      api.reload('6f36020e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6f36020e&", function () {
      api.rerender('6f36020e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/communityPartyBuilding/swimming/order/detail.vue"
export default component.exports